"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const WeiboIcon = createIcon({
  displayName: "WeiboIcon",
  viewBox: "0 0 45 36.77",
  path: (
    <>
      <path
        d="M36.38,18.89c-.77-.49-1.63-.89-2.59-1.19-.2-.07-.34-.12-.43-.15-.08-.03-.18-.1-.3-.19-.12-.09-.16-.2-.11-.32.04-.12.08-.29.11-.51.75-1.94.75-3.45,0-4.51-.77-1.03-2.05-1.55-3.84-1.55s-3.85.5-6.18,1.49l-.15.05c-.1.03-.21.06-.34.09-.13.03-.25.03-.36.01-.12-.02-.2-.08-.25-.18-.05-.1-.04-.27.03-.51.75-2.45.59-4.21-.5-5.29-1.24-1.25-3.3-1.31-6.19-.18-2.89,1.13-5.74,3.12-8.57,5.98-2.14,2.16-3.79,4.34-4.96,6.54-1.16,2.2-1.74,4.26-1.74,6.21,0,1.82.54,3.51,1.63,5.05,1.09,1.55,2.52,2.82,4.31,3.83,1.78,1,3.79,1.79,6.04,2.36,2.24.57,4.54.85,6.9.85s4.62-.26,6.79-.78c2.17-.52,4.06-1.22,5.67-2.1,1.62-.88,3.03-1.87,4.23-2.98,1.21-1.11,2.12-2.26,2.74-3.47.62-1.21.93-2.39.93-3.53,0-1.08-.28-2.07-.85-2.95-.57-.89-1.24-1.58-2.01-2.07ZM28.18,30.5c-2.45,2-5.54,3.2-9.28,3.58-2.44.24-4.74.06-6.89-.53-2.15-.59-3.9-1.51-5.23-2.76-1.34-1.25-2.08-2.69-2.23-4.31-.23-2.47.87-4.7,3.33-6.7,2.45-2,5.54-3.2,9.28-3.58,2.44-.24,4.74-.06,6.89.53,2.15.59,3.9,1.51,5.23,2.76,1.34,1.25,2.08,2.69,2.23,4.31.23,2.47-.87,4.7-3.33,6.7Z"
        fill="currentColor"
      />
      <path
        d="M19.63,20c-1.77-.46-3.54-.3-5.28.48-1.75.78-3.02,1.95-3.8,3.52-.79,1.6-.84,3.19-.16,4.75.68,1.56,1.91,2.63,3.7,3.2,1.86.61,3.73.51,5.62-.3,1.89-.81,3.21-2.08,3.97-3.8.75-1.69.73-3.3-.06-4.83-.8-1.53-2.12-2.54-3.98-3.03ZM16.95,28.21c-.37.57-.89.98-1.57,1.2-.68.23-1.3.21-1.87-.06-.57-.27-.93-.7-1.08-1.28-.15-.58-.04-1.16.33-1.73.35-.56.85-.95,1.51-1.17.65-.22,1.26-.21,1.83.03.59.25.96.68,1.13,1.27.17.59.08,1.17-.28,1.75ZM19.31,25.15c-.12.22-.3.38-.55.47-.25.09-.49.1-.73.01-.5-.24-.61-.62-.33-1.14.12-.22.3-.38.54-.47.24-.09.48-.1.72-.01.22.08.36.24.44.47.08.23.05.45-.09.67Z"
        fill="currentColor"
      />
      <path
        d="M35.87,14.04c.18.36.47.61.85.75.39.12.76.08,1.12-.1.36-.19.61-.47.74-.86.32-.95.37-1.94.16-2.98-.21-1.04-.66-1.95-1.37-2.75-.7-.79-1.55-1.35-2.54-1.66-.99-.31-1.98-.36-2.99-.14-.4.08-.71.3-.93.65-.22.35-.28.72-.2,1.13.07.41.28.72.63.94.35.22.73.29,1.13.2,1.05-.22,1.95.08,2.69.89.74.81.94,1.75.6,2.81-.12.39-.08.76.1,1.13Z"
        fill="currentColor"
      />
      <path
        d="M44.75,9.6c-.43-2.14-1.37-4.02-2.82-5.64-1.46-1.64-3.2-2.77-5.22-3.41-2.02-.63-4.07-.73-6.13-.29-.47.1-.83.35-1.09.75-.26.4-.34.83-.24,1.3.1.47.35.84.75,1.1.4.26.84.34,1.3.24,1.46-.3,2.9-.23,4.34.22,1.44.45,2.68,1.25,3.72,2.42,1.04,1.15,1.71,2.48,2.01,4,.3,1.52.22,2.97-.25,4.36-.13.46-.09.9.13,1.32.22.42.55.71,1,.86.45.15.89.12,1.31-.1.42-.22.7-.56.85-1.01.65-1.94.77-3.98.34-6.12Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default WeiboIcon;
